(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ggt-welcome-popup"] && !Shopify.designMode) return;
  try {
    (function(){
  var COOKIE_NAME = 'ggt_popup_dismissed';
  var DELAY_MS = 10000;
  function getCookie(name){
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days){
    var d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }
  if (getCookie(COOKIE_NAME)) { return; }
  var overlay = document.getElementById('ggt-popup-overlay');
  if (!overlay) { return; }
  if (overlay.parentElement !== document.body) {
    document.body.appendChild(overlay);
  }
  var shown = false;
  function showPopup(){
    if (shown) { return; }
    shown = true;
    overlay.classList.add('ggt-popup-visible');
    setCookie(COOKIE_NAME, '1', 30);
  }
  function dismiss(){
    overlay.classList.remove('ggt-popup-visible');
    setCookie(COOKIE_NAME, '1', 30);
  }
  var timer = setTimeout(showPopup, DELAY_MS);
  document.addEventListener('mouseleave', function(e){
    if (e.clientY <= 0) { showPopup(); }
  });
  overlay.querySelector('.ggt-popup-close').addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e){
    if (e.target === overlay) { dismiss(); }
  });
  function isValidEmail(v){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }
  var submitBtn = document.getElementById('ggt-popup-submit-btn');
  var emailInput = document.getElementById('ggt-popup-email-input');
  var errorEl = document.getElementById('ggt-popup-error');
  if (submitBtn) {
    submitBtn.addEventListener('click', function(){
      var email = emailInput ? emailInput.value.trim() : '';
      if (!isValidEmail(email)) {
        if (errorEl) { errorEl.style.display = 'block'; }
        return;
      }
      if (errorEl) { errorEl.style.display = 'none'; }
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird gesendet...';
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', String.fromCharCode(10003));
      body.append('contact[email]', email);
      body.append('contact[tags]', 'newsletter');
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).then(function(){
        document.getElementById('ggt-popup-step-form').style.display = 'none';
        document.getElementById('ggt-popup-step-code').style.display = 'block';
        setCookie(COOKIE_NAME, '1', 30);
      }).catch(function(){
        document.getElementById('ggt-popup-step-form').style.display = 'none';
        document.getElementById('ggt-popup-step-code').style.display = 'block';
        setCookie(COOKIE_NAME, '1', 30);
      });
    });
  }
  var copyBtn = document.getElementById('ggt-popup-copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function(){
      navigator.clipboard.writeText('WILLKOMMEN10').then(function(){
        copyBtn.textContent = 'Kopiert!';
        setTimeout(function(){ copyBtn.textContent = 'Kopieren'; }, 2000);
      });
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
